import {fetchDelete, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const updateOrganizationVaccine = async({token, organizationVaccine}) => {
  const url = `${generateEndpoint("updateOrganizationVaccine")}`;
  return fetchPatch(url, token, {organizationVaccine});
};

export const createOrganizationVaccine = async({token, organizationVaccine}) => {
  const url = `${generateEndpoint("createOrganizationVaccine")}`;
  return fetchPost(url, token, {organizationVaccine});
};

export const deleteOrganizationVaccine = async({token, id}) => {
  const url = `${generateEndpoint("deleteMedicalOrganization")}`;
  return fetchDelete(url, token, {id});
};
